import { MASK_APPEARANCES } from "./constants";
/* eslint-disable-next-line import/prefer-default-export */
export var getPresetMaskConfig = function getPresetMaskConfig(mask) {
  return MASK_APPEARANCES[mask] || MASK_APPEARANCES["default"];
};